import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from './sds-text.styles';
import { SDS_SIZES } from '../types';

type Size = SDS_SIZES;

export interface SDSTextProps {
	size?: Size;
	strong?: boolean;
	tall?: boolean;
}

export class SDSTextComponent extends LitElement {
	// Styling
	static override styles = [styles];

	// Reactive Props
	@property({ type: String, reflect: true }) size: Size = 'md';
	@property({ type: Boolean, reflect: true }) strong: boolean = false;
	@property({ type: Boolean, reflect: true }) tall: boolean = false;

	override render() {
		return html`<p><slot></slot></p>`;
	}
}
